import React from "react";

export default function SQL_DROP_DEFAULT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_DROP_DEFAULT</h1>
      <p>This is the SQL_DROP_DEFAULT component generated from the SQL JSON.</p>
    </div>
  );
}
